
import Vue from 'vue'
import axios from 'axios'

let car = ['dlcd.dolinkhub.com']
// src/main.js (或入口文件)
const getPublicPath = () => {
  const pathSegments = window.location.pathname.split('/')
  console.log(pathSegments, 'pathSegments')
  const projectId = pathSegments[1] || '' // 根据 URL 结构调整索引
  if (car.indexOf(window.location.host) !== -1) {
    const href = `${window.document.location.origin}/${projectId}/`
    Vue.prototype.$baseUrl = href
    axios.defaults.baseURL = href
    return `/${projectId}/qc-portal/`
  } else {
    axios.defaults.baseURL = `${window.document.location.origin}/`
    Vue.prototype.$baseUrl = `${window.document.location.origin}/`
    return '/qc-portal/'
  }
}

export default getPublicPath()
